module.exports = __webpack_public_path__ + "img/service3-01.bccf4567.png";